import { ChipColors, ChipSizes, ChipVariant } from '@/constants/chipTypes';
import { Chip } from '@mui/material';

interface ChipProps {
  label: string;
  variant: ChipVariant;
  size: ChipSizes;
  color: ChipColors;
}

export const InertChip = ({ label, size, color, variant }: ChipProps) => {
  return (
    <Chip
      label={label}
      size={size}
      color={color}
      variant={variant}
    />
  );
};
